export default __webpack_public_path__ + "static/9Li3pb14-4df24b39b8c760fda9efaaea605ba2fd.jpeg";